import Skeleton from "react-loading-skeleton";

const height = 100;

const StatusCheckSkeleton = () => {
  return (
    <>
      <Skeleton count={1} height={height} width={475} borderRadius={12} />
      <Skeleton count={1} height={height} width={475} borderRadius={12} />
      <Skeleton count={1} height={height} width={475} borderRadius={12} />
      <Skeleton count={1} height={height} width={475} borderRadius={12} />
    </>
  );
};

export default StatusCheckSkeleton;
